import { render, staticRenderFns } from "./RequestLogNewTap.vue?vue&type=template&id=215fe9e8&"
import script from "./RequestLogNewTap.vue?vue&type=script&lang=js&"
export * from "./RequestLogNewTap.vue?vue&type=script&lang=js&"
import style0 from "./RequestLogNewTap.vue?vue&type=style&index=0&id=215fe9e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports